import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import AddMessageSkeleton from '../AddMessage/skeleton';
import ConversationNavSkeleton from '../ConversationNav/skeleton';

export const MessageListContentsSkeleton = (): JSX.Element => {
  return (
    <>
      {[...Array(8)].map((_, idx) => {
        return (
          <Box key={idx} css={{ width: '100%' }}>
            <Bone type="chatBubble" css={{ width: '50%', marginBlock: 'tighter' }} />
            <Bone type="chatBubble" css={{ width: '58.33%', marginBlock: 'tighter' }} />
            <Box css={{ display: 'flex', justifyContent: 'flex-end', marginBlock: 'tighter' }}>
              <Bone type="chatBubble" css={{ width: '350px' }} />
            </Box>
            <Bone type="chatBubble" css={{ width: '75%', marginBlock: 'tighter' }} />
          </Box>
        );
      })}
    </>
  );
};

export const MessageListSkeleton = (): JSX.Element => {
  return (
    <>
      <Box
        css={{
          width: '100%',
          paddingLeft: 'default',
          paddingRight: 'tight',
          flex: 1,
          overflowY: 'auto',
        }}
      >
        <MessageListContentsSkeleton />
      </Box>
      <AddMessageSkeleton />
    </>
  );
};

export const MessageListEmptyContainerSkeleton = (): JSX.Element => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        flex: 1,
      }}
    >
      <ConversationNavSkeleton />
      <MessageListSkeleton />
    </Box>
  );
};
